module.exports = __webpack_public_path__ + "img/logo16.e8ee4ddc.png";